import { Template } from "./templates";

export interface Dish {
  id?: string;
  title: string;
  price: number | null;
  description: string;
  image?: string[];
}

export interface Drink extends Dish {
  alcoholic: boolean;
}

export type Dessert = Dish;
export type Appetizer = Dish;
export type MainDish = Dish;

export enum Flow {
  DINE_IN = "dine-in",
  DELIVERY = "delivery",
  PICKUP = "pick-up",
  OTHER = "other",
}

export interface MenuSection {
  category: string;
  categoryTitle?: string;
  isVisible?: boolean;
  columns?: number;
  template?: "column-free" | "default-filled";
  products?: string[]; // ordered product IDs for this section
}

export interface DraftMenu {
  title: string;
  description?: string;
  image: string[];
  template?: Template["id"];
  flow: Flow[];
  isPublished: boolean;
  structure?: MenuSection[];
}

export interface NewMenu extends DraftMenu {
  createdBy: string;
  createdAt: number;
}

export interface Menu extends Omit<NewMenu, "image"> {
  id: string;
  data?: string;
  order?: number;
  image: string;
  lastUpdatedBy: string;
  lastUpdatedAt: number;
}
